import { Component, ElementRef, EventEmitter, Input, Output, ViewChild } from '@angular/core';
import { FormControl } from '@angular/forms';
import { uniqueId } from 'lodash';

import { ProtocolDroidService } from '../../../../shared/protocol-droid/services/protocol-droid.service';

@Component({
  selector: 'app-simple-dropdown',
  templateUrl: './simple-dropdown.component.html',
  styleUrls: ['./simple-dropdown.component.scss']
})
export class SimpleDropdownComponent {
  @ViewChild('dropdownContent') dropdownContent: ElementRef;
  @Input() fullWidth?: boolean;
  @Input() input: FormControl;
  @Input() dicoValues: Record<string, string | boolean>;
  @Input() isDisabled?: boolean;
  @Input() isDropup?: boolean;
  @Input() showErrors: boolean;
  @Input() largeButton: boolean;
  @Input() add?: boolean;
  @Input() newStyle: boolean;
  @Input() customClass?: string;
  @Input() modeHorizontal?: boolean;
  @Input() isTypeDataKey?: boolean;
  @Input() isScope?: boolean;
  @Input() btnClass?: boolean;
  @Input() highlightSelectedItem = false;
  @Input() alphaSort?: boolean;
  @Input() caretHeight?: number;
  @Input() textSize?: string;
  @Output() preSelect?: EventEmitter<string>;
  @Output() postSelect?: EventEmitter<string>;
  @Output() addItem?: EventEmitter<string>;
  @Output() actionOnHover?: EventEmitter<string>;
  @Output() dropdownOpen?: EventEmitter<boolean> = new EventEmitter();
  id: string;
  newItem: string;
  isAddingNewItem: boolean;

  constructor(
    public protocolDroidService: ProtocolDroidService,
    private elementRef: ElementRef
  ) {
    this.id = uniqueId();
    this.preSelect = new EventEmitter();
    this.postSelect = new EventEmitter();
    this.addItem = new EventEmitter();
    this.actionOnHover = new EventEmitter();
    this.fullWidth = false;
    this.isDisabled = false;
    this.add = false;
    this.newItem = '';
    this.isAddingNewItem = false;
    this.newStyle = true;
    this.modeHorizontal = false;
    this.isTypeDataKey = false;
    this.isScope = false;
    this.btnClass = true;
  }

  get values() {
    const values = Object.keys(this.dicoValues || {});
    return this.alphaSort ? values.sort((a, b) => a.localeCompare(b)) : values;
  }

  hoverAction(action: string) {
    this.actionOnHover.emit(action);
  }

  addNewItem(cancel?: boolean) {
    if (!cancel) this.addItem.emit(this.newItem);
    this.newItem = '';
    this.isAddingNewItem = false;
  }

  select(value: string) {
    this.preSelect.emit(value);
    this.input.patchValue(value);
    this.postSelect.emit(value);
    this.input.markAsDirty();

    // Used to enable 'enter' event after selection
    if (this.dropdownContent && this.dropdownContent.nativeElement) this.dropdownContent.nativeElement.focus();

    // close dropdownmenu
    const menu = this.elementRef.nativeElement.querySelectorAll('.dropdown-menu')?.[0];
    if (menu?.classList.contains('show')) this.dropdownContent.nativeElement.click();
  }

  public isOpen(isOpen: boolean): void {
    this.dropdownOpen.emit(isOpen);
  }
}
